
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface SystemAppFilterProps {
  value: 'all' | 'system' | 'non-system';
  onValueChange: (value: 'all' | 'system' | 'non-system') => void;
}

export const SystemAppFilter = ({ value, onValueChange }: SystemAppFilterProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor="system-app-filter" className="text-sm font-medium text-gray-700">
        App Type
      </Label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger id="system-app-filter" className="w-full">
          <SelectValue placeholder="Filter by app type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Apps</SelectItem>
          <SelectItem value="system">System Apps Only</SelectItem>
          <SelectItem value="non-system">User Apps Only</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
